import { useEffect, useState } from "react";
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts";
import { ILandingConsoleStore, useLandingConsoleStore } from "../data/store"

export default function useColumnsCount(count: number): number {
    const currentDimensionEdit      = useLandingConsoleStore((state: ILandingConsoleStore) => state.currentDimensionEdit)
    const [columnsCount, setColumnsCount] = useState<number>(count)
    useEffect(() => { 
        if(currentDimensionEdit >= WINDOW_WIDTH.SCREEN ) {
            setColumnsCount( count ) 
        }
        else if(currentDimensionEdit >= WINDOW_WIDTH.TABLET && count > 3 ) {
            setColumnsCount( 3 )
        }
        else if(currentDimensionEdit >= WINDOW_WIDTH.TABLET && count > 2 ) {
            setColumnsCount( 2 )
        }
        else if(currentDimensionEdit >= WINDOW_WIDTH.MOBILE && count > 3 ) {
            setColumnsCount( 2 )
        }
        else {
            setColumnsCount( 1 )
        }
    }, [currentDimensionEdit, count])
    return columnsCount
}